import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';

import useAxios from '../useAxios';

import { AUTH_ENDPOINT } from '../../constants/apiEndpoints';

import {
  LogInRequest,
  LogInWithOTPRequest,
  LogInResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
} from '../../@types/auth';

export const useLogIn = () => {
  const axios = useAxios();

  return useMutation((payload: LogInRequest) =>
    axios.post<
      LogInResponse,
      AxiosResponse<LogInResponse, LogInRequest>,
      LogInRequest
    >(AUTH_ENDPOINT, payload, {
      validateStatus: statusCode =>
        (statusCode >= 200 && statusCode < 300) || statusCode === 412, // 412 is for OTP
    }),
  );
};

export const useOTPLogIn = () => {
  const axios = useAxios();

  return useMutation((payload: LogInWithOTPRequest) =>
    axios.post<
      LogInResponse,
      AxiosResponse<LogInResponse, LogInWithOTPRequest>,
      LogInWithOTPRequest
    >(`${AUTH_ENDPOINT}/otp`, payload),
  );
};

export const useForgotPassword = () => {
  const axios = useAxios();

  return useMutation((payload: ForgotPasswordRequest) =>
    axios.post<
      string,
      AxiosResponse<string, ForgotPasswordRequest>,
      ForgotPasswordRequest
    >(`${AUTH_ENDPOINT}/password/forget`, payload),
  );
};

export const useResetPassword = () => {
  const axios = useAxios();

  return useMutation((payload: ResetPasswordRequest) =>
    axios.post<
      string,
      AxiosResponse<string, ResetPasswordRequest>,
      ResetPasswordRequest
    >(`${AUTH_ENDPOINT}/password/reset`, payload),
  );
};
